import { theme } from '../../Assets/Styles/theme'

export const styles = {
  breadcrumbsWrapper: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    display: 'flex',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    color: '#707087',
    fontSize: '12px',
    '&:hover': {
      textDecoration: 'none',
      color: '#707087',
    },
  },
  icon: {
    marginRight: '10px',
    display: 'flex',
    '& > svg': {
      width: 20,
      height: 20,
      fill: theme.colors.primary,
    },
  },
}
